import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import {
  BADGE_COLOR_CLASSES,
  BADGE_MAX_COUNT,
  BadgeColor,
} from './badge.model';

@Component({
  selector: 'fc-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'inline-flex h-16 shrink-0 items-center justify-center rounded-full text-xs font-normal whitespace-nowrap',
    '[class]': 'appearanceClasses()',
  },
  template: `{{ label() }}`,
})
export class BadgeComponent {
  readonly count = input.required<number>();
  readonly color = input<BadgeColor>('primary');

  protected readonly label = computed(() =>
    this.count() > BADGE_MAX_COUNT
      ? `${BADGE_MAX_COUNT}+`
      : String(this.count()),
  );
  protected readonly appearanceClasses = computed(
    () =>
      `${BADGE_COLOR_CLASSES[this.color()]} ${this.label().length === 1 ? 'w-16' : 'w-26'}`,
  );
}
